import CommonLoading from '@/components/CommonLoading';
import { ResultModal } from '@/pages/Index/ResultModal';
import { HistoryItem, HistoryStore } from '@/utils/store/store';
import { Empty } from 'antd';
import { MdMoreHoriz } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { SiFigshare } from "react-icons/si";
import { useSnapshot } from 'valtio';
import HistoryMenu from "@/pages/Index/static/HistoryMenu.png";
import React, {useEffect} from "react";

interface HistoryListProps {
  timeIndex: number; // 0: 今天, 1: 前7天, 2: 前30天
  userId: string;
}

const HistoryList: React.FC<HistoryListProps> = ({
  timeIndex,
  userId
}) => {
  const { delItem, genTitle, titleLoadingMap, data } = useSnapshot(HistoryStore);
  
  // 直接从HistoryStore获取对应时间段的数据
  const contentList = data[timeIndex] || [];

  useEffect(() => {
  }, [titleLoadingMap,data]);

  if (contentList.length === 0) {
    // return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="" description="暂无" />;
    return <div className={"h-3"}></div>
  }


  return (
    <>
      {contentList.map((item, index) => {
        /**
         * 获取显示的标题内容
         * @returns 标题字符串或加载组件
         */
        const getDisplayTitle = () => {
          if (titleLoadingMap[item.id]) {
            return <CommonLoading />;
          }
          
          // console.log("getDisplayTitle",item.id,item.title);
          return item.title ? item.title : JSON.parse(item.result)["default"];
        };

        return (
          <div key={item.id} className="grid grid-cols-8 gap-0.5 hover:cursor-pointer hover:bg-[#F6F7FC] rounded-full p-1.5 m-0.5">
            <button
              className="col-span-7   justify-start   truncate text-start text-[#242630] hover:cursor-pointer"
              onClick={() => ResultModal(item)}
            >
              {getDisplayTitle()}
            </button>

            <div className="group relative col-span-1">
              <button className="h-5 w-6  object-contain transition duration-150 ease-in-out hover:translate-x-0.5 hover:scale-125 hover:cursor-pointer flex items-center justify-center">
                {/*<MdMoreHoriz style={{ color: "gray" }} />*/}
                <img
                  src={HistoryMenu}
                  className="w-6 h-6"
                />
              </button>
              
              <ul className="menu bg-[#FAFAFA] rounded-box fixed z-[9999] w-32 p-1 shadow-lg border border-gray-200 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none group-hover:pointer-events-auto">
                <li className="text-[14px] text-[#242630] ">
                  <a onClick={() => delItem(userId, item.id)}>
                    <RiDeleteBinLine />删除
                  </a>
                </li>
                <li className="text-[14px] text-[#242630] ">
                  <a onClick={() => genTitle(userId, item.id)}>
                    <SiFigshare />推理标题
                  </a>
                </li>
              </ul>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default HistoryList;